// The <head> payload of a page: title, meta description and structured data.
//
//   export default {
//     mixins: [pageHead],
//     pageHead: {
//       title: 'Aukcje - Japonia Cars',
//       description: '…',
//       schema: pageSchema({ path: '/aukcje/', name: 'Aukcje' }),
//     },
//   }
//
// A page whose head depends on the route declares `pageHead()` as a function
// instead; it is called with the component as `this`.
//
// The structured data is removed when the view goes away. Each instance tracks
// the node it appended rather than clearing every one, because the incoming
// view is created before the outgoing one is unmounted.

const schemaNodes = new WeakMap()

function setDescription(content) {
  let meta = document.querySelector('meta[name="description"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', content)
}

export default {
  created() {
    const declared = this.$options.pageHead
    const head = (typeof declared === 'function' ? declared.call(this) : declared) || {}

    if (head.title) document.title = head.title
    setDescription(head.description || '')

    if (head.schema) {
      const el = document.createElement('script')
      el.type = 'application/ld+json'
      el.textContent = JSON.stringify(head.schema)
      document.head.appendChild(el)
      schemaNodes.set(this, el)
    }
  },

  beforeUnmount() {
    const el = schemaNodes.get(this)
    if (el) el.remove()
    schemaNodes.delete(this)
  },
}
